// Conversation deep links (e.g. the ones the analytics MCP hands to an AI client) must survive
// the login round trip. Lives here so the auth hook and the login forms share one source.

// Namespaced to avoid collisions on the same eTLD+1 with unrelated apps.
export const POST_LOGIN_REDIRECT_KEY = 'aspe_post_login_redirect';

export const DEFAULT_POST_LOGIN_PATH = '/dashboard';

const MAX_AGE_MS = 15 * 60 * 1000;

const UUID = '[0-9a-fA-F]{8}-(?:[0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}';

// Only in-app conversation links: anything else would turn this into an open redirect.
const CONVERSATION_LINK = new RegExp(`^/bot/[^/?#]+/chats\\?(?:[^#]*&)?session_id=${UUID}(?:[&#]|$)`);

export function stashPostLoginRedirect(pathWithSearch: string): void {
  if (!CONVERSATION_LINK.test(pathWithSearch)) return;
  try {
    window.sessionStorage.setItem(
      POST_LOGIN_REDIRECT_KEY,
      JSON.stringify({ path: pathWithSearch, at: Date.now() }),
    );
  } catch {
    // Storage blocked: the user lands on the dashboard, as before.
  }
}

export function clearPostLoginRedirect(): void {
  try {
    window.sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  } catch {
    // Nothing stored or storage blocked: nothing to clear.
  }
}

export function peekPostLoginRedirect(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    if (!raw) return null;
    const { path, at } = JSON.parse(raw);
    // Re-validated on read: any script on this origin can write sessionStorage.
    if (typeof path === 'string' && CONVERSATION_LINK.test(path)
      && Date.now() - Number(at) < MAX_AGE_MS) {
      return path;
    }
  } catch {
    // Unreadable or malformed stash: drop it below.
  }
  clearPostLoginRedirect();
  return null;
}

export function postLoginPath(): string {
  return peekPostLoginRedirect() ?? DEFAULT_POST_LOGIN_PATH;
}
